"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ListItemSecondaryAction_1 = __importDefault(require("@material-ui/core/ListItemSecondaryAction"));
var ListItemSecondaryAction = function (_a) {
    var classes = _a.classes, children = _a.children;
    return (react_1.default.createElement(ListItemSecondaryAction_1.default, { classes: classes }, children));
};
exports.default = ListItemSecondaryAction;
